import { styled } from "@mui/material/styles";
import PrimaryButton from "shared/components/PrimaryButton";

export const StyledButton = styled(PrimaryButton)`
  &.MuiButton-root {
    font-size: 1rem;
    font-weight: 700;

    &.contained {
      border-radius: 0.5rem;
    }
  }
`;
